import { client } from '@/client';

// 用户列表
export function getRoles(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/console/kafka/security/${clusterName}/roles`, others);
}

// 删除角色
export function deleteRole(params) {
  return client.delete('/api/console/kafka/security/deleteRole', params);
}

// 修改role
export function updateRole(data) {
  return client.put('/api/console/kafka/security/updateRole', data);
}

// 新增role
export function addRole(data) {
  return client.put('/api/console/kafka/security/createRole', data);
}

// kafka Acl overview
export function getRoleOverview(clusterName) {
  return client.get(`/api/resource/kafka/security/${clusterName}/overview`);
}

export function getGrants(params) {
  return client.post(`/api/resource/kafka/security/allAclInfo`, params);
}

// 删除权限
export function deletePermission(params) {
  return client.delete('/api/resource/kafka/security/deleteAcl', params, {
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  });
}

// 资源下拉
export function getResourceType() {
  return client.get(`/api/resource/kafka/security/resourceType`);
}

// 添加权限
export function createPermissionBase(params) {
  return client.put('/api/resource/kafka/security/createKafkaBaseAcl', params);
}

export function createPermissionCustom(params) {
  return client.put('/api/resource/kafka/security/createKafkaCustomAcl', params);
}

// 根据认证方式获取资源 同kop
export function getClusterResources(params) {
  const { clusterName, ...others } = params || {};
  return client.get(`/api/resource/kop/security/${clusterName}/clusterResources`, others);
}

// 获取集群下Group
export function getGroupResources(params) {
  const { clusterName, ...others } = params || {};
  return client.get(`/api/resource/kafka/security/${clusterName}/clusterGroups`, others);
}

export function getAclOperationOptions(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/resource/kafka/security/operation`, others);
}

// 获取topic下ACLs
export function getTopicAclInfo(params) {
  return client.post(`/api/resource/kafka/security/topicAclInfo`, params);
}
